<template>
  <div class="map">
    <HMTMapFrame />
  </div>
</template>

<script>
  import HMTMapFrame from '@/shared/components/MapFrame';

  export default {
    name: 'Map',
    components: {
      HMTMapFrame
    }
  };
</script>

<style lang="scss">
  @import '../../styles/mixins.scss';

  .map {
    height: calc(100vh - 90px);

    @include smScreen() {
      height: 650px;
    }

    .hmt-map-frame__cover-btn {
      background-color: var(--map-button-bg-color);

      &:hover {
        background-color: var(--map-button-bg-hover-color);
      }
    }
  }
</style>
